import {FilterValue} from 'antd/es/table/interface';
import {showCommunicationError} from 'helpers/alerts';
import {action, runInAction} from 'mobx';
import {CalendarState} from 'store/common/CalendarState';
import {TableState} from 'store/common/TableState';
import {ApiServiceActionFindByGetRequest, ServiceActionListDto, ServiceStatus} from '../../../../../PRMGApiClient';
import {Api} from '../../../../../PRMGApiClient/ApiClient';
import {Mixin} from 'ts-mixer';

type ServiceFilters = Pick<
  ApiServiceActionFindByGetRequest,
  'filtersDateRangeStart' | 'filtersDateRangeEnd' | 'filtersRequired' | 'filtersStatus' | 'filtersCarId'
>;

export class ServicesState extends Mixin(TableState<ServiceActionListDto, ServiceFilters>, CalendarState) {
  constructor() {
    super();
  }

  @action
  loadTableItems() {
    this.isLoading = true;
    Api.ServiceAction.apiServiceActionFindByGet({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortPropertyName: this.sortPropertyName,
      sortDirection: this.sortDirection,
      filtersCarId: this.filtersCarId,
      ...this.filters,
    })
      .then((res) => {
        runInAction(() => {
          this.items = res.content?.items || [];
          this.total = res.content?.total || 0;
        });
      })
      .catch(showCommunicationError)
      .finally(() => {
        this.isLoading = false;
      });
  }

  @action
  loadCalendarItems() {
    this.isLoading = true;
    this.setDefaultDateRangeCalendar();

    Api.ServiceAction.apiServiceActionFindByGet({
      filtersDateRangeStart: this.filtersDateRangeStartCalendar,
      filtersDateRangeEnd: this.filtersDateRangeEndCalendar,
      pageSize: 1000,
    })
      .then((res) => {
        runInAction(() => {
          this.items = res.content?.items || [];
        });
      })
      .catch(showCommunicationError)
      .finally(() => {
        this.isLoading = false;
      });
  }

  setFilters(filters: Record<keyof ServiceActionListDto, FilterValue | null>) {
    this.filters.filtersStatus = (filters.status as ServiceStatus[]) ?? undefined;
    this.filters.filtersDateRangeStart = this.getDate(filters.startDateTime);
    this.filters.filtersDateRangeEnd = this.getDate(filters.endDateTime);
    this.filters.filtersRequired = !!filters.name?.[0];
    this.loadTableItems();
  }
}
